export default function (t, columns) {
  const rowFields = [];
  columns.forEach((column) => {
    if (column.fields.length > 1) {
      rowFields.push({
        title: column.name,
        customProps: {
          colSpan: 3,
          align: 'center',
        },
      });
    } else {
      rowFields.push({
        title: column.name,
        customProps: {
          rowSpan: 2,
          align: 'center',
        },
      });
    }
  });
  return rowFields;
}
